"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveawayActionToJSON = exports.GiveawayActionFromJSONTyped = exports.GiveawayActionFromJSON = exports.instanceOfGiveawayAction = void 0;
var ActionStrategyId_1 = require("./ActionStrategyId");
var ActionType_1 = require("./ActionType");
var GiveawayParticipantEntry_1 = require("./GiveawayParticipantEntry");
/**
 * Check if a given object implements the GiveawayAction interface.
 */
function instanceOfGiveawayAction(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "score" in value;
    isInstance = isInstance && "entries" in value;
    isInstance = isInstance && "strategyId" in value;
    return isInstance;
}
exports.instanceOfGiveawayAction = instanceOfGiveawayAction;
function GiveawayActionFromJSON(json) {
    return GiveawayActionFromJSONTyped(json, false);
}
exports.GiveawayActionFromJSON = GiveawayActionFromJSON;
function GiveawayActionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'type': (0, ActionType_1.ActionTypeFromJSON)(json['type']),
        'score': json['score'],
        'entries': (json['entries'].map(GiveawayParticipantEntry_1.GiveawayParticipantEntryFromJSON)),
        'strategyId': (0, ActionStrategyId_1.ActionStrategyIdFromJSON)(json['strategyId']),
    };
}
exports.GiveawayActionFromJSONTyped = GiveawayActionFromJSONTyped;
function GiveawayActionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'type': (0, ActionType_1.ActionTypeToJSON)(value.type),
        'score': value.score,
        'entries': (value.entries.map(GiveawayParticipantEntry_1.GiveawayParticipantEntryToJSON)),
        'strategyId': (0, ActionStrategyId_1.ActionStrategyIdToJSON)(value.strategyId),
    };
}
exports.GiveawayActionToJSON = GiveawayActionToJSON;
